import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorIcon from '@mui/icons-material/Error';
import type { ValidationDecision } from '../../types';

interface Props {
  decision: ValidationDecision;
  score?: number | null;
  size?: 'small' | 'medium';
}

export const ValidationStatusBadge: React.FC<Props> = ({ decision, score, size = 'small' }) => {
  const scoreLabel = score != null ? ` ${score.toFixed(0)}/100` : '';

  switch (decision) {
    case 'PASS':
      return (
        <Chip
          icon={<CheckCircleIcon />}
          label={`PASS${scoreLabel}`}
          color="success"
          size={size}
          sx={{ fontWeight: 700 }}
        />
      );
    case 'NEEDS_IMPROVEMENT':
      return (
        <Chip
          icon={<WarningAmberIcon />}
          label={`NEEDS IMPROVEMENT${scoreLabel}`}
          color="warning"
          size={size}
          sx={{ fontWeight: 700 }}
        />
      );
    case 'FAIL':
    default:
      return (
        <Chip
          icon={<ErrorIcon />}
          label={`FAIL${scoreLabel}`}
          color="error"
          size={size}
          sx={{ fontWeight: 700 }}
        />
      );
  }
};
